import AdminTenantsPage from "@/pages/admin/AdminTenantsPage";
import { ShoppingBag } from "lucide-react";

export default function Vendors() {
  return (
    <AdminTenantsPage
      portal="VENDOR"
      title="Vendors"
      subtitle="Approve, suspend, reactivate, assign plans, impersonate, export or delete any Vendor tenant."
      entityLabel="Vendor"
      Icon={ShoppingBag}
      testId="admin-vendors"
      rowTestPrefix="vendor"
    />
  );
}
